import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

export default function IconWithProgress({
  icon,
  progress,
  currentSection,
  isThisSectionCurrentSection,
}) {
  const { palette } = useTheme();

  const circularProgressSize = 60;
  const circularProgressThickness = 2;
  return (
    <>
      <Box position="relative" display="inline-flex">
        <CircularProgress
          aria-label="progress"
          variant="determinate"
          size={circularProgressSize}
          value={100}
          thickness={circularProgressThickness}
          style={{ color: palette.grey[300] }}
        />
        <CircularProgress
          aria-label={`progress ${currentSection} ${progress}`}
          variant="determinate"
          value={progress}
          size={circularProgressSize}
          style={{
            color: isThisSectionCurrentSection
              ? palette.info.main
              : palette.grey[300],
            position: "absolute",
          }}
          thickness={circularProgressThickness}
        />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {icon}
        </Box>
      </Box>
    </>
  );
}
